import React from 'react';
import { CgClose } from 'react-icons/cg';

const DisplayImage = ({ imageUrl, onClose }) => {
  return (
    <div className='overlay'>
      <style jsx>{`
        .overlay {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.5);
        }

        .image-modal {
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          border-radius: 8px;
          max-width: 800px;
          margin: auto;
          padding: 16px;
          position: relative;
        }

        .close-icon {
          position: absolute;
          top: 8px;
          right: 8px;
          font-size: 24px;
          cursor: pointer;
          color: #ff6b6b;
          transition: color 0.3s ease;
        }

        .close-icon:hover {
          color: #ff4c4c;
        }

        .image-container {
          display: flex;
          justify-content: center;
          padding: 16px;
          max-width: 80vh;
          max-height: 80vh;
          overflow: hidden;
        }

        .full-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      `}</style>
      <div className='image-modal'>
        <div className='close-icon' onClick={onClose}>
          <CgClose />
        </div>
        <div className='image-container'>
          <img src={imageUrl} className='full-image' alt="Product" />
        </div>
      </div>
    </div>
  );
}

export default DisplayImage;
